import Button from "components/Button/Button";
import React, { LegacyRef, useRef, useState } from "react";
import "components/InputField/InputField.scss";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  numeric?: boolean;
  floating?: boolean;
  innerRef?: LegacyRef<HTMLInputElement>;
  showEditButton?: boolean;
  errors?: string[];
  commaList?: boolean;
  ofValue: string | undefined;
}

const InputKeyField = ({
  label,
  numeric,
  floating,
  innerRef,
  showEditButton,
  errors,
  commaList,
  ofValue,
  ...props
}: IProps) => {
  const [isEditActive, setIsEditActive] = useState<boolean>(false);
  const localRef = useRef<HTMLInputElement | null>(null);

  const setRefs = (el: HTMLInputElement | null) => {
    localRef.current = el;
    if (typeof innerRef === "function") {
      innerRef(el);
    } else if (innerRef && "current" in (innerRef as any)) {
      (innerRef as React.MutableRefObject<HTMLInputElement | null>).current = el;
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    if (numeric) {
      const clipboard = event.clipboardData.getData("text");
      if (!/\d/.test(clipboard)) {
        event.preventDefault();
        return;
      }
    }
  };

  const clearAndNotifyParent = () => {
    if (localRef.current) {
      localRef.current.value = "";
    }

    if (props.onChange) {
      const syntheticEvent = {
        target: {
          name: props.name ?? "",
          value: "",
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      props.onChange(syntheticEvent);
    }
  };

  return (
    <div className={"input-field " + (props.className ?? "")}>
      {label && <label className="input-field__label">{label}</label>}

      <div className="inputWithButton">
        <input
          {...props}
          ref={setRefs}
          className="input-field__input"
          onPaste={handlePaste}
          onKeyDown={(e) => {
          }}
          disabled={!isEditActive}
          defaultValue={isEditActive ? "" : ofValue ?? ""}
        />
        <Button
          type="button"
          className="button--secondary button--solid"
          icon={isEditActive ? "cross" : "pencil"}
          onClick={() => setIsEditActive(!isEditActive)}
          tabIndex={-1}
        />
        {!isEditActive && (
          <Button
            type="button"
            className="button--secondary button--solid"
            icon="trash"
            style={{ marginRight: "35px" }}
            onClick={clearAndNotifyParent}
            tabIndex={-1}
          />
        )}
      </div>

      {errors?.length! > 0 && (
        <p>
          {errors?.map((e, i) => (
            <small key={`validation-error-${i}`}>{e}</small>
          ))}
        </p>
      )}
    </div>
  );
};

export default InputKeyField;